<p>
    <fa-icon
    class="iconExclamation"
    size="6x"
    [icon]="faRotateExclamation"
    ></fa-icon>
  </p>
  <p>
    {{ 'k004255' | translate }}
    <!-- Token: Oh no! Too many attempts. -->
  </p>
  <p>{{ textTooManyAttemps }}</p>
  <button
  mat-raised-button
  mat-dialog-close
  type="button"
  id="btoSMSnext"
  class="buttonPortal lg my-4"
  color="blue"
>
  <span>{{ 'k000444' | translate }}</span>
  <!-- Token: Close -->
</button>